import React from "react"
import { useSpringCarousel } from 'react-spring-carousel-js'
import { StaticImage } from "gatsby-plugin-image"
import styled from "styled-components"

const CarouselWrapper = styled.div`
    display: flex;
    
    
`
const CarouselItem = styled.div`
    padding-right: 1rem;
    padding-bottom: 2rem;
    width: 200px;
`

const Arrows = styled.ul`
    // height: 40px;
    // width: 40px;
    float: right;
    list-style: none;
    padding-left: 2rem;
    margin: 0;
`
const LeftArrowButton = styled.li`
    background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 150 150' style='enable-background:new 0 0 150 150;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23D33D17;%7D%0A%3C/style%3E%3Cpath class='st0' d='M5,75c0,38.7,31.3,70,70,70s70-31.3,70-70S113.7,5,75,5S5,36.3,5,75z M91.4,45.2V103L46.6,74.1L91.4,45.2 L91.4,45.2z'/%3E%3C/svg%3E");
    height: 20px;
    width: 20px;
    // transition: 0.2s;
    // opacity: 0.6;
    margin-bottom: 0.5rem;
    // &:hover {
    //   opacity: 1;
    // }
`
const RightArrowButton = styled.li`
    background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 150 150' style='enable-background:new 0 0 150 150;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23D33D17;%7D%0A%3C/style%3E%3Cpath class='st0' d='M75,5C36.3,5,5,36.3,5,75s31.3,70,70,70s70-31.3,70-70S113.7,5,75,5z M58.7,45.2l44.7,28.9L58.6,103L58.7,45.2 L58.7,45.2z'/%3E%3C/svg%3E");
    height: 20px;
    width: 20px;
    transition: 0.2s;
    opacity: 0.6;
    &:hover {
      opacity: 1;
    }
`

const RecentPostsCarousel = ({ children }: any) => {
  const {
    carouselFragment,
    slideToPrevItem,
    slideToNextItem,
    
  } = useSpringCarousel({
    withLoop: true,
    itemsPerSlide: 3,
    items: [
      {
        id: "CarouselItem-1",
        renderItem: <CarouselItem background="#2c3e50">
                        {children[0]}
                    </CarouselItem>,
      },
      {
        id: "CarouselItem-2",
        renderItem: <CarouselItem background="#c0392b">
                        {children[1]}
                    </CarouselItem>,
      },
      {
        id: "CarouselItem-3",
        renderItem: <CarouselItem background="#c0392b">
                        {children[2]}
                    </CarouselItem>,
      },
      {
        id: "CarouselItem-4",
        renderItem: <CarouselItem background="#c0392b">
                        {children[3]}
                    </CarouselItem>,
      },
      {
        id: "CarouselItem-5",
        renderItem: <CarouselItem background="#c0392b">
                        {children[4]}
                    </CarouselItem>,
      },
    ],
  });

  return (
    <CarouselWrapper>
        {carouselFragment}
        <Arrows>
            <LeftArrowButton type="prev" onClick={slideToPrevItem} />
            <RightArrowButton type="next" onClick={slideToNextItem} />
        </Arrows>
    </CarouselWrapper>
  );
}

export default RecentPostsCarousel;